import { RouteObject } from "react-router-dom";
import { SmsTemplatesList } from "../pages/admin/sms-templates/SmsTemplatesList";
import { SmsTemplateDetail } from "../pages/admin/sms-templates/SmsTemplateDetail";
import { SmsTemplateCreate } from "../pages/admin/sms-templates/SmsTemplateCreate";
import { SmsTemplateEdit } from "../pages/admin/sms-templates/SmsTemplateEdit";

export const smsTemplatesRoutes: RouteObject[] = [
  {
    id: "sms-templates-list",
    index: true,
    element: <SmsTemplatesList />,
  },
  {
    id: "sms-template-detail",
    path: ":id",
    element: <SmsTemplateDetail />,
  },
  {
    id: "sms-template-create",
    path: "create",
    element: <SmsTemplateCreate />,
  },
  {
    id: "sms-template-edit",
    path: ":id/edit",
    element: <SmsTemplateEdit />,
  },
];
